import {useEffect, useState,useContext} from 'react'
import PropTypes from 'prop-types'
import {AppBar, Tab,Tabs,Box,Typography } from '@mui/material'
import { useParams,useNavigate } from 'react-router-dom';
import { useQueryParam, StringParam } from 'use-query-params';
import './DataItem.css'
import {getItemVal,buildItemsList,getIcon} from '../../Data/GeneralFanction'
import {getAll} from '../../Data/Utils'
import IframeShow from '../IframeShow/IframeShow'
import "../../config.json";
import { LanguageContext } from '../../context'
import { useTranslate } from '../../Components/Translate/Translate'
import DataInfo from '../DataInfo/DataInfo';
import Breadcrams from '../Breadcrams/Breadcrams';
import { Helmet } from 'react-helmet';
import useEffectOnce from '../../hooks/useEffectOnce'
import { minHeight } from '@mui/system';
import MetaTags from '../MetaTags/MetaTags';



function TabPanel(props) {
    const { children, value, index, ...other } = props;
    const { language } = useContext(LanguageContext);
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
      
    };
  }
  

const DataItem = () => {

    const [value, setValue] =useState(0); 
    const [itemId,setItemId]=useState(0);
    const [dataSet,setDataSet]=useState();   
    const [tabsData,setTabsData]=useState([]);   
    const [isLive,setIsLive]=useState('');   
    const [title,setTitle]=useState('');   
    const [description,setDescription]=useState('');  
     
    
    const {selectedTab,id,langParam}=useParams();
    var { language,switchLang } = useContext(LanguageContext);
    const typesDatabasesLabel = useTranslate("TypesDatabases");
    const navigate = useNavigate();


    const [ids, setIds] = useQueryParam('ids', StringParam);
    const [tab, setTab] = useQueryParam('tab', StringParam);
    

    const getDataItem = async () => {

     var config = require('../../config.json');

      const webUrl=window.srcSiteUrl;
       const apiUrl=config.apiByIdUrl;
       const dataSetList=config.lists.dataSet.name; 
       const view=config.lists.dataSet.view;
       let {data} = await getAll(`${webUrl}${apiUrl}?listName=${dataSetList}&id=${parseInt(id)}&view=${view}`);
       var x=buildItemsList(data);
       if(x.length>0){
         setDataSet(x[0]) ;
         if(x[0].ds_islive.Value=="True")
           setIsLive("Live");
         language=="he"?setTitle(x[0].ds_name_heb.Value):setTitle(x[0].ds_name_en.Value)
         setDescription(x[0]["ds_desc_"+language].Value);

         BuildJsonFlat(x[0]);
       }
     };

    useEffect(()=>{      
      
      var config = require('../../config.json');
    
     if(langParam != undefined && language!=langParam){
      language=langParam;
     
    }
    if(ids!=undefined&& ids!=''){
      if(tab=="analyze"){
        navigate(`/${language}/dataItem/${ids}/graph`)
      }
      else
        navigate(`/${language}/dataItem/${ids}/${tab}`)
    }
    if(selectedTab!=undefined){
      var indexTab=config.DataItemTabs.find(t=>t.label.en.toLocaleLowerCase()==selectedTab.toLocaleLowerCase());
      setValue(indexTab.index );
      if(indexTab!==undefined)
        setValue(indexTab.index );
      else
        setValue(0);
    }
    
      setTabsData(config.DataItemTabs);  
      setItemId(parseInt(id));
      getDataItem();
      
     

      },[]);

      useEffect(()=>{  

        setItemId(parseInt(id));
        getDataItem();

      },[id]);


      useEffect(()=>{  

        var config = require('../../config.json');
        if(selectedTab!=undefined){
          var indexTab=config.DataItemTabs.find(t=>t.label.en.toLocaleLowerCase()==selectedTab.toLocaleLowerCase());
          if(indexTab!=undefined)
            setValue(indexTab.index );
          else
            setValue(0);
       }
      },[selectedTab]);

      useEffect(()=>{  
        if(dataSet!=undefined){
          language=="he"?setTitle(dataSet.ds_name_heb.Value):setTitle(dataSet.ds_name_en.Value);  
          setDescription(dataSet["ds_desc_"+language].Value);  
        } 
      },[language]);
     

    const handleChange = (event, newValue) => {
        setValue(newValue);
        let url=window.location.pathname;
        if(url.lastIndexOf('/')==url.length-1)
        url=url.substring(0,url.length-1);
        if(selectedTab!=undefined){
           url =window.location.pathname.substring(0,window.location.pathname.lastIndexOf('/'));
        }
        
        let tabName=tabsData.find(e=>e.index==newValue);
        navigate(`${url}/${tabName.label.en}`)
    };

    const handleChangeIndex = (index) => {
        setValue(index);
      };

      const ShowTabPanelByCondition=(tab,index)=>{

        var flag=false;  
        var fieldCheck=tab.field[language].split(';') ; 
        fieldCheck.map((field,i)=>{
          var val=getItemVal(field,dataSet);
         
          flag=flag ? true : (val != null && val.trim() != '' ? true : false);
        })  
        return  (flag && tab.dataType!="none" &&
                  <TabPanel value={value} index={index} key={index}>
                  { tab.dataType=="iframe" && <IframeShow tab={tab} dataSet={dataSet} />}
                  {tab.dataType=="data" && <DataInfo tab={tab} dataSet={dataSet} showTitle={true}/>}
                  </TabPanel>
        )
      };

      const BuildJsonFlat=(data)=>{
        var name=language=="he"?data["ds_name_heb"].Value.replace(/'/g, "’").replace(/"/g, '’’'):data["ds_name_en"].Value.replace(/'/g, "’").replace(/"/g, '’’');
        var flatScript = document.createElement('script');
            var flatJson =
                "{" +
                "'@context': 'http://schema.org', " +
                "'@type': 'Event', " +
                "'name': '" +name + "', " +
                "'description': '" + data["ds_desc_"+language].Value.replace(/'/g, "’").replace(/"/g, '’’') + "', " +
                "'startDate':'', " +
                "'endDate': '', " +
                "'location': {" +
                "'@type': 'Place'," +
                "'address': {'@type': 'PostalAddress', " +
                "'addressLocality': 'Tel Aviv', " +
                "'addressCountry':'IL', " +
                "'streetAddress': ''" +
                "}" +
                ", 'name': ''" +
                "}, 'image': {" +
                "'@type': 'ImageObject', " +
                "'contentUrl': ''" +
                "}, 'isAccessibleForFree': ''" +
                "}";


            flatScript.type = 'application/ld+json';
            flatScript.id = 'itemFlatScript'

            flatScript.text = flatJson.replace(/'/g, "\"");
            document.getElementsByTagName('head')[0].appendChild(flatScript);
      }


      const GetHeightOfItem=()=>{
        return  window.innerHeight-340-89;
      }

  return (
    
      <main className='data-item-container' style={{minHeight:GetHeightOfItem()}}>
      <MetaTags title={`${title} - ${selectedTab}`} description={description}/>
   
    <div className="title-data">
      <h1 id="main-content-title" tabIndex="-1">{title}</h1>
      {isLive!=''?<div className="live-icon"/>:''}
      </div>
        <Breadcrams pagename={title}></Breadcrams>
    <Box sx={{ width: '100%'}}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs onChange={handleChange}  value={value} aria-label={typesDatabasesLabel}>
          {/* { 
                tabsData.map((tab,index)=>{                
                  return   getItemVal(tab.field[language],dataSet)!=null && tab.dataType!="none" &&
                    <Tab label={tab.label[language]} icon={<img src={getIcon(tab.icon)} alt=""/>} iconPosition="start" value={index} {...a11yProps(index)} key={index}/>   
                
                })
              } */}

{ 
                tabsData.map((tab,index)=>{ 
                  var flag=false;  
                  var fieldCheck=tab.field[language].split(';') ; 
                  fieldCheck.map((field,i)=>{
                    var val=getItemVal(field,dataSet);
                   
                    flag=flag ? true : (val != null && val.trim() != '' ? true : false);
                  })  
                  return   flag && tab.dataType!="none" &&
                    <Tab label={tab.label[language]} icon={<img src={getIcon(tab.icon)} alt=""/>} iconPosition="start" value={index} {...a11yProps(index)} key={index}/>   
                
                })
              }
          </Tabs>
        </Box>
        {
         tabsData.map((tab,index)=>{
          return <>{
            ShowTabPanelByCondition(tab,index)
          }</>
       })
      }   
    
       
      
        </Box>
        </main>
  )
}

export default DataItem

